import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import './../../styles/site/NavbarTop.css';
import Logo from './../../components/logo.webp'
import * as globals from './../../components/GlobalScripts.js';

const NavbarTop = () => {
    return (
        <>
            <div className="navbar-top">
                <div className='navs'>
                    <div className='primary-nav'>
                        <div>
                            <Link to="/">
                                <img className='logo' src={Logo} alt='Logo' />
                            </Link>
                        </div>
                        {globals.isAuthenticated() && (
                            <Link to="/user" className="button-primary">
                                Volver
                            </Link>
                        )}
                        {!globals.isAuthenticated() && (
                            <Link to="/login" className="button-primary">
                                Iniciar sesión
                            </Link>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default NavbarTop;